import styled, { css } from 'styled-components'

export const ScrollWrapper = styled.div<{ mobileScrollable: boolean }>`
  ${({ mobileScrollable }) =>
    mobileScrollable &&
    css`
      overflow-x: scroll;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding-bottom: 6px;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    `}
`

export const Wrapper = styled.div<{ mobileScrollable: boolean }>`
  display: flex;
  align-items: center;
  ${({ mobileScrollable }) =>
    mobileScrollable &&
    css`
      display: flex;
      width: max-content;
    `}
`

export const BreadcrumbLink = styled.span`
  display: flex;
  margin-right: 8px;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.core.DEEP_GRAY};
  transition: all 0.3s ease;
  &:last-child {
    color: ${({ theme }) => theme.palette.text.MAIN};

    .icon {
      display: none;
    }
  }
  &:hover {
    color: ${({ theme }) => theme.palette.secondary.MAIN};
  }
`
